export const state = {
  djTotalAmount: null,
  producerTotalAmount: null,
  quarters: [],
  quartersProducer: [],
  currentDjRange: null,
  currentProducerRange: null
};
